import { createSlice } from "@reduxjs/toolkit";
import * as Act from "./actions";

const initialState = {
  loading: false,
  PRESCRIPTIONMAILLIST: [],
  totalCount: 0,
};

const slice = createSlice({
  name: "PRESCRIPTIONMAILLIST",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(Act.getPrescriptionMailList.pending, (state, action) => ({
      ...state,
      loading: true,
    }));
    builder.addCase(Act.getPrescriptionMailList.fulfilled, (state, { payload }) => ({
      ...state,
      loading: false,
      PRESCRIPTIONMAILLIST: payload,
      totalCount: payload.total_record_count || 0, 
    }));
    builder.addCase(Act.getPrescriptionMailList.rejected, (state, action) => ({
      ...state,
      loading: false,
      PRESCRIPTIONMAILLIST: [],
      totalCount: 0,
    }));
  },
});

export default slice;